import React from 'react';
import { BetsTable } from '@/common/components';
import { PaginationV2 } from '@/common/components/Pagination/PaginationV2';
import { useRaceDetailsSRM } from '../hooks/SRMBets.hooks';
import { useSRMBetsColumns } from '../config/SRMBets.config';

export default function SRMAllBetsTab() {
  const {
    data,
    isLoading,
    next,
    previous,
    previousDisabled,
    nextDisabled,
    hidePagination,
  } = useRaceDetailsSRM();
  const { columns } = useSRMBetsColumns();
  const { bets } = data || {
    bets: [],
    paging: {
      next_offset: null,
    },
  };

  return (
    <>
      <BetsTable
        columns={columns}
        data={bets as Api['SRMultiRaceBetResponse'][]}
        loading={isLoading}
        initialSort={[{ id: 'exposure', desc: true }]}
      />
      <PaginationV2
        {...{
          onNext: next,
          onPrev: previous,
          hidePagination,
          nextDisabled,
          previousDisabled,
        }}
      />
    </>
  );
}
